import React, { createContext, useState, useEffect } from 'react';
import { IBaseState } from '../../types/types';
import { AlertType, IAlertProps } from '../components/Alert';
import checkSession from '../../utils/checkSession';

interface IRegisterContext extends IBaseState {
  showModal: boolean;
  toggleModal: (visible: boolean) => void;
}

const initialState: IRegisterContext = {
  showModal: false,
  toggleModal: (visible: boolean) => { },
  alertProps: {
    type: AlertType.NONE,
  },
  setAlertProps: (alerts: IAlertProps) => { },
};


const RegisterContext = createContext<IRegisterContext>(initialState);

export const RegisterProvider = (props: any) => {

  useEffect(() => {
    try {
      checkSession();
    } catch (error) {

    }
  }, []);

  const [state, setState] = useState<IRegisterContext>({
    ...initialState,
    setAlertProps: (alertProps: IAlertProps) => {
      setState((state) => ({
        ...state,
        alertProps,
      }));
    },
    toggleModal: (visible: boolean) => {
      setState((state) => ({
        ...state,
        showModal: visible,
      }));
    },
  });

  return (
    <RegisterContext.Provider value={state}>
      {props.children}
    </RegisterContext.Provider>
  );
};

export default RegisterContext;
